import classnames from 'classnames/bind'
import React from 'react'

import ImageWithPlaceholder, {
  ImageWithPlaceholderProps,
} from '~/components/ImageWithPlaceholder'

import css from './styles.module.scss'

const cx = classnames.bind(css)

/**
 * Hero article slice
 * @param props
 * @returns Slice
 */
export interface HeroArticleProps {
  className?: string
  image: ImageWithPlaceholderProps
}

function HeroArticle({ className, image }: HeroArticleProps) {
  return (
    <section className={cx(css.HeroArticle, className)}>
      {image && (
        <ImageWithPlaceholder layout="fill" objectFit="cover" {...image} />
      )}
    </section>
  )
}

HeroArticle.defaultProps = {}

export default HeroArticle
